/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S2_Card3_BodyInputs */

const tr_cerez_s2_card3_body = /** @type {(inputs: Cerez_S2_Card3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şu an kullanılmıyor. Dil ve tema tercihleriniz yalnızca siz seçtiğinizde ya da hesabınızda kayıtlı dil uygulandığında yazıldığı için zorunlu kayıtlar arasında yer alır. İleride işlevsel bir çerez eklenmesi halinde ayrıca rıza istenir.`)
};

const en_cerez_s2_card3_body = /** @type {(inputs: Cerez_S2_Card3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not in use at present. Your language and theme preferences are written only when you choose them or when the language saved in your account is applied, so they are listed with the necessary entries. If a functional cookie is added in the future, consent will be requested separately.`)
};

const de_cerez_s2_card3_body = /** @type {(inputs: Cerez_S2_Card3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derzeit nicht im Einsatz. Ihre Sprach- und Designeinstellung werden nur geschrieben, wenn Sie sie wählen oder die in Ihrem Konto gespeicherte Sprache übernommen wird, und stehen deshalb bei den erforderlichen Einträgen. Kommt künftig ein Funktions-Cookie hinzu, wird gesondert um Einwilligung gebeten.`)
};

const ru_cerez_s2_card3_body = /** @type {(inputs: Cerez_S2_Card3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сейчас не используются. Ваши настройки языка и темы записываются только когда вы их выбираете или когда применяется язык, сохранённый в вашей учётной записи, поэтому они указаны среди необходимых записей. Если в будущем будет добавлен функциональный файл cookie, согласие будет запрошено отдельно.`)
};

/**
* | output |
* | --- |
* | "Not in use at present. Your language and theme preferences are written only when you choose them or when the language saved in your account is applied, so th..." |
*
* @param {Cerez_S2_Card3_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s2_card3_body = /** @type {((inputs?: Cerez_S2_Card3_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S2_Card3_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s2_card3_body(inputs)
	if (locale === "de") return de_cerez_s2_card3_body(inputs)
	if (locale === "ru") return ru_cerez_s2_card3_body(inputs)
	return tr_cerez_s2_card3_body(inputs)
});